import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';
import { idbSyncMiddleware } from '../Helpers/idbSyncMiddleware';

export const Store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({ thunk: true, immutableCheck: false, serializableCheck: false }).concat(
            idbSyncMiddleware,
        ),
    devTools: process.env.NODE_ENV !== 'production',
});

export const getStoreState = () => Store.getState();
